import * as React from 'react'
import TabBar from 'src/components/ui/entity/EntityTabBar'
import TabBarItem from 'src/components/ui/entity/EntityTabBarItem'
import UIMessages from 'src/utils/ui-messages'

export interface StationUserPaneHeaderProps {
  activeTab: string
  handleChangeTab: (tab: string) => void
}

class StationUserPaneHeader extends React.Component<StationUserPaneHeaderProps> {
  constructor(props: StationUserPaneHeaderProps) {
    super(props)
  }

  public render() {
    const { activeTab, handleChangeTab } = this.props
    const { goinZones, userInfo } = UIMessages.stationUser

    return (
      <TabBar>
        <TabBarItem active={activeTab === userInfo}>
          <div onClick={() => handleChangeTab(userInfo)}>{userInfo}</div>
        </TabBarItem>
        <TabBarItem active={activeTab === goinZones}>
          <div onClick={() => handleChangeTab(goinZones)}>{goinZones}</div>
        </TabBarItem>
      </TabBar>
    )
  }
}

export default StationUserPaneHeader



// WEBPACK FOOTER //
// ./src/components/station-user/view/StationUserPaneHeader.tsx